import "../sass/project.scss";
import * as bootstrap from "bootstrap";
const { Tooltip, Popover } = bootstrap;
window.bootstrap = bootstrap;

/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

(() => {
  'use strict'

  const getStoredTheme = () => localStorage.getItem('theme')
  const setStoredTheme = theme => localStorage.setItem('theme', theme)

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  const setTheme = theme => {
    if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#bd-theme')

    if (!themeSwitcher) {
      return
    }

    const themeSwitcherText = document.querySelector('#bd-theme-text')
    const activeThemeIcon = document.querySelector('.theme-icon-active use')
    const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)
    // const svgOfActiveBtn = btnToActive.querySelector('svg use').getAttribute('href')

    document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
      element.classList.remove('active')
      element.setAttribute('aria-pressed', 'false')
    })

    btnToActive.classList.add('active')
    btnToActive.setAttribute('aria-pressed', 'true')
    // activeThemeIcon.setAttribute('href', svgOfActiveBtn)
    const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
    themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

    if (focus) {
      themeSwitcher.focus()
    }
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme())

    document.querySelectorAll('[data-bs-theme-value]')
      .forEach(toggle => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-bs-theme-value')
          setStoredTheme(theme)
          setTheme(theme)
          showActiveTheme(theme, true)
        })
      })
  })
})()

document.addEventListener("DOMContentLoaded", function (event) {
  // Initialize all tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );

  // Initialize all popovers
  const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]'
  );
  const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new Popover(popoverTriggerEl)
  );

  // Download Modal Control
  const downloadModal = document.getElementById("downloadModal");
  if (!downloadModal) {
    return;
  }
  downloadModal.addEventListener("show.bs.modal", (event) => {
    const button = event.relatedTarget;
    const launchBtn = document.getElementById("gLaunchBtn");

    // If opened programmatically (bulk mode), relatedTarget is null — skip
    // single-strategy setup and clear the per-strategy summary data
    if (!button) {
      if (launchBtn) {
        launchBtn.classList.toggle("d-none", document.getElementById("bulkMode").value === "true");
      }
      downloadModal.dataset.symbol = "";
      downloadModal.dataset.lotSize = "";
      if (window.__guidedStrategyChanged) window.__guidedStrategyChanged();
      return;
    }

    const strategyId = button.getAttribute("data-bs-strategy-id");
    downloadModal.dataset.symbol = button.getAttribute("data-bs-symbol") || "";
    downloadModal.dataset.lotSize =
      button.getAttribute("data-bs-lot-size") || "";
    if (window.__guidedStrategyChanged) window.__guidedStrategyChanged();

    const modalTitle = downloadModal.querySelector(".modal-title");
    const modalBodyInput = downloadModal.querySelector(
      ".modal-body #strategyId"
    );
    const bulkModeInput = document.getElementById("bulkMode");

    modalBodyInput.value = strategyId;
    if (bulkModeInput) bulkModeInput.value = "false";
    if (modalTitle) modalTitle.textContent = "Strategy Files Download";
    if (launchBtn) launchBtn.classList.remove("d-none");
  });

  // Guided Setup is the download interface, including when no firm presets exist.
  const guidedPanel = document.getElementById("guidedPanel");
  if (guidedPanel) {
    const STAGE_ORDER = ["single-phase", "challenge", "verification", "post-funded"];
    const STAGE_LABELS = {
      "single-phase": "Single Phase",
      challenge: "Phase 1",
      verification: "Phase 2",
      "post-funded": "Funded",
    };

    let presets = {};
    try {
      const presetsEl = document.getElementById("propFirmPresets");
      presets = JSON.parse(presetsEl ? presetsEl.textContent : "null") || {};
    } catch (e) {
      presets = {};
    }

    const g = {};
    [
      "gFirm", "gChallenge", "gStage", "gAccountSize", "gSourceBadge",
      "gCustomAccountSize", "gCustomAccountSizeWrap",
      "gProfitTarget", "gPtBadge", "gPtHint", "gMaxLoss", "gDdBadge",
      "gRiskOn", "gRiskValue", "gRiskBadge", "gRiskHint",
      "gConsOn", "gConsValue", "gConsBadge",
      "gConnection", "gHedge", "gCloseHighNews", "gNotes",
      "gSumSelection", "gSumRows", "gResetAll",
    ].forEach((id) => (g[id] = document.getElementById(id)));

    let overrides = {};

    function fillSelect(select, names, labels) {
      select.innerHTML = "";
      names.forEach((name) => {
        const option = document.createElement("option");
        option.value = name;
        option.textContent = (labels && labels[name]) || name;
        select.appendChild(option);
      });
    }

    function firmData() {
      return presets[g.gFirm.value] || null;
    }

    function challengeData() {
      const firm = firmData();
      return (firm && firm.challenges && firm.challenges[g.gChallenge.value]) || null;
    }

    function availableStages() {
      const challenge = challengeData();
      if (!challenge || !challenge.stages) return STAGE_ORDER;
      return STAGE_ORDER.filter((stage) => challenge.stages[stage]);
    }

    function newsPadding() {
      // Mirrors _build_strategy_config: firm "Other" resolves to the ACG
      // preset, challenge-stage override wins over the firm-level one
      const firmKey =
        g.gFirm.value === "Other" ? "Alpha Capital Group" : g.gFirm.value;
      const firm = presets[firmKey] || {};
      const challenge = (firm.challenges || {})[g.gChallenge.value] || {};
      const stageData = (challenge.stages || {})[g.gStage.value] || {};
      return (
        stageData.news_padding ||
        (firm.news_padding || {})[g.gStage.value] || {
          high_padding: 30,
          padding_offset: 60,
        }
      );
    }

    function newsSymbolBypass() {
      // Same resolution as newsPadding(): challenge-stage wins, then
      // firm-level keyed by stage; firm "Other" resolves to the ACG preset
      const firmKey =
        g.gFirm.value === "Other" ? "Alpha Capital Group" : g.gFirm.value;
      const firm = presets[firmKey] || {};
      const challenge = (firm.challenges || {})[g.gChallenge.value] || {};
      const stageData = (challenge.stages || {})[g.gStage.value] || {};
      return Boolean(
        stageData.news_symbol_bypass ||
          (firm.news_symbol_bypass || {})[g.gStage.value]
      );
    }

    function legacyDefaults(stage) {
      if (stage === "challenge") return { max_loss: 10, profit_target: 10 };
      if (stage === "verification") return { max_loss: 10, profit_target: 5 };
      if (stage === "single-phase") return { max_loss: 6, profit_target: 10 };
      return { max_loss: 10, profit_target: 3 };
    }

    function suggestion() {
      const stage = g.gStage.value;
      const challenge = challengeData();
      if (challenge && challenge.stages && challenge.stages[stage]) {
        return {
          source: `${g.gFirm.value} preset`,
          values: challenge.stages[stage],
          notes: challenge.notes || "",
        };
      }
      return {
        source: "Standard defaults",
        values: legacyDefaults(stage),
        notes: challenge ? challenge.notes || "" : "",
      };
    }

    function setBadge(el, state) {
      const map = {
        suggested: ["text-bg-primary", "Suggested"],
        changed: ["text-bg-warning", "Changed"],
        default: ["text-bg-secondary", "Strategy default"],
      };
      el.className = `badge ${map[state][0]}`;
      el.textContent = map[state][1];
    }

    function accountSize() {
      return g.gAccountSize.value === "custom" ? g.gCustomAccountSize.value : g.gAccountSize.value;
    }

    function renderGuided() {
      const { source, notes } = suggestion();
      const suggested = suggestion().values;
      g.gSourceBadge.textContent = source;
      setBadge(g.gPtBadge, overrides.profit_target ? "changed" : "suggested");
      setBadge(g.gDdBadge, overrides.max_loss ? "changed" : "suggested");
      setBadge(
        g.gRiskBadge,
        g.gRiskOn.checked
          ? overrides.max_risk || suggested.max_risk == null
            ? "changed"
            : "suggested"
          : "default"
      );
      setBadge(g.gConsBadge, g.gConsOn.checked ? "changed" : "default");

      const riskValue = parseFloat(g.gRiskValue.value) || 0;
      g.gRiskHint.textContent = g.gRiskOn.checked
        ? `Cap ${g.gRiskValue.value}% → effective EA protector ${Math.max(riskValue - 0.2, 0).toFixed(1)}% (backend applies a 0.2 buffer).`
        : "Unchecked = the strategy file is left untouched.";
      g.gNotes.textContent = notes || "No firm notes available.";
      g.gPtHint.textContent =
        g.gStage.value === "post-funded"
          ? "3% is the recommended post-funded goal (editable)."
          : "";

      g.gSumSelection.textContent = `${g.gFirm.value} · ${g.gChallenge.value} · ${STAGE_LABELS[g.gStage.value]}`;
      const accountValue = Number(accountSize());
      const accountLabel = accountValue > 0
        ? accountValue.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
        : "Enter an account size";
      const padding = newsPadding();
      const onOff = (on) => (on ? "On" : "Off");
      const connection = g.gConnection.value;
      // Per-strategy data stashed on the modal by the show.bs.modal handler;
      // empty in bulk mode where strategies differ
      const symbol = downloadModal.dataset.symbol || "";
      const lotSize = parseFloat(downloadModal.dataset.lotSize);
      // Downloads always write RandomizeLS with MaxLSOffset=10, so the
      // effective lot is the file's LS ±10%
      const trim = (v) => String(parseFloat(v.toFixed(2)));
      const lotLabel =
        lotSize > 0 ? `${trim(lotSize * 0.9)}–${trim(lotSize * 1.1)} (±10%)` : "Varies";
      const rows = [
        ["Instrument", symbol || "Multiple"],
        ["Account", accountLabel],
        ["Lot size", lotLabel],
        ["Profit target", `${g.gProfitTarget.value}%`],
        ["Max drawdown", `${g.gMaxLoss.value}%`],
        [
          "Max risk cap",
          g.gRiskOn.checked
            ? `${g.gRiskValue.value}% → EA ${Math.max(riskValue - 0.2, 0).toFixed(1)}%`
            : "Off",
        ],
        [
          "Consistency",
          g.gConsOn.checked ? `${g.gConsValue.value}% (−1% buffer applied)` : "None",
        ],
        [
          "High news action",
          g.gCloseHighNews.checked ? "Close trades + pause new" : "Pause new trades",
        ],
        [
          "High news close window",
          `±${padding.high_padding}–${padding.high_padding + padding.padding_offset} min`,
        ],
        ["Currency bypass", newsSymbolBypass() ? "On" : "Off"],
        ["Heron", onOff(connection === "heron")],
        ["Trading Connectivity", onOff(connection === "tc")],
        ["Hedge", onOff(g.gHedge.checked)],
        ["PropFirm platform is MT5", connection === "mt5" ? "Manual Mode" : "No"],
      ];
      // "On" / "Manual Mode" mean the option is actively changing the file —
      // shade those blue so they stand out from the inert rows
      const isActive = (value) => value === "On" || value.startsWith("Manual");
      g.gSumRows.innerHTML = rows
        .map(
          ([key, value]) =>
            `<div class="d-flex justify-content-between border-bottom py-1" style="font-size: 0.85rem;"><span class="text-muted">${key}</span>${
              isActive(value)
                ? `<span class="badge text-bg-primary">${value}</span>`
                : `<b>${value}</b>`
            }</div>`
        )
        .join("");
    }

    function loadSuggestions() {
      overrides = {};
      const suggested = suggestion().values;
      g.gProfitTarget.value = suggested.profit_target;
      g.gMaxLoss.value = suggested.max_loss;
      g.gRiskOn.checked = suggested.max_risk != null;
      g.gRiskValue.value = suggested.max_risk != null ? suggested.max_risk : 1;
      g.gConsOn.checked = suggested.daily_goal != null;
      g.gConsValue.value = suggested.daily_goal != null ? suggested.daily_goal : 40;
      renderGuided();
    }

    function refreshChallenges() {
      const firm = firmData();
      const names = firm ? Object.keys(firm.challenges || {}) : [];
      fillSelect(g.gChallenge, names.concat(["Other"]));
    }

    function refreshStages() {
      const keep = g.gStage.value;
      const stages = availableStages();
      fillSelect(g.gStage, stages, STAGE_LABELS);
      if (stages.includes(keep)) g.gStage.value = keep;
    }

    fillSelect(g.gFirm, Object.keys(presets).concat(["Other"]));
    g.gFirm.value = "Other";
    refreshChallenges();
    g.gChallenge.value = "Other";
    refreshStages();
    g.gStage.value = "challenge";

    g.gFirm.addEventListener("change", () => {
      refreshChallenges();
      refreshStages();
      loadSuggestions();
    });
    g.gChallenge.addEventListener("change", () => {
      refreshStages();
      loadSuggestions();
    });
    g.gStage.addEventListener("change", loadSuggestions);
    g.gAccountSize.addEventListener("change", () => {
      const custom = g.gAccountSize.value === "custom";
      g.gCustomAccountSizeWrap.classList.toggle("d-none", !custom);
      g.gCustomAccountSize.disabled = !custom;
      if (custom) g.gCustomAccountSize.focus();
      renderGuided();
    });
    g.gCustomAccountSize.addEventListener("input", renderGuided);
    [
      ["gProfitTarget", "profit_target"],
      ["gMaxLoss", "max_loss"],
      ["gRiskValue", "max_risk"],
      ["gConsValue", "daily_goal"],
    ].forEach(([id, key]) => {
      g[id].addEventListener("input", () => {
        overrides[key] = true;
        renderGuided();
      });
    });
    // Heron, Trading Connectivity and an MT5 prop platform are mutually
    // exclusive, so they share one select instead of three checkboxes
    ["gRiskOn", "gConsOn", "gHedge", "gConnection", "gCloseHighNews"].forEach(
      (id) => g[id].addEventListener("change", renderGuided)
    );
    g.gResetAll.addEventListener("click", loadSuggestions);

    // Re-render the summary when the modal opens for a (different) strategy
    window.__guidedStrategyChanged = renderGuided;
    window.__guidedFormData = () => ({
      download_model: "v2",
      strategy_id: document.getElementById("strategyId").value,
      bulk_mode: document.getElementById("bulkMode").value,
      broker: document.getElementById("broker").value,
      prop_firm: g.gFirm.value,
      prop_challenge: g.gChallenge.value,
      stage: g.gStage.value,
      account_size: accountSize(),
      max_loss: g.gMaxLoss.value,
      profit_target: g.gProfitTarget.value,
      low_max_risk: g.gRiskOn.checked,
      max_risk_value: g.gRiskOn.checked ? g.gRiskValue.value : "1",
      limit_max_daily_goal: g.gConsOn.checked,
      max_daily_goal: g.gConsOn.checked ? g.gConsValue.value : "40",
      enable_sync_with_heron: g.gConnection.value === "heron",
      enable_sync_with_hedge: g.gHedge.checked,
      enable_sync_with_tc: g.gConnection.value === "tc",
      close_trades_high_news: g.gCloseHighNews.checked,
      prop_platform_mt5: g.gConnection.value === "mt5",
      mdl_reset_time: (firmData() && firmData().mdl_reset_time) || "00:00",
    });

    loadSuggestions();
  }
});


function downloadFile(type) {
  if (typeof window.__guidedFormData !== "function") return;
  const numericFields = ["gCustomAccountSize", "gProfitTarget", "gMaxLoss"];
  if (document.getElementById("gRiskOn").checked) numericFields.push("gRiskValue");
  if (document.getElementById("gConsOn").checked) numericFields.push("gConsValue");
  if (numericFields.some((id) => !document.getElementById(id).reportValidity())) return;
  const formData = window.__guidedFormData();

  // --- Bulk download mode ---
  const isBulk = formData["bulk_mode"] === "true";
  if (isBulk) {
    if (type === "launcher") return; // not supported in bulk mode

    const bulkForm = document.getElementById("bulkDownloadForm");
    if (!bulkForm || !window.selectedStrategies) return;

    bulkForm.action = `/v2/download-bulk/${type}/`;
    document.getElementById("bulkStrategyIds").value =
      Array.from(window.selectedStrategies).join(",");

    // Add all settings as hidden inputs (clear previous dynamic ones first)
    bulkForm.querySelectorAll(".dynamic-input").forEach((el) => el.remove());

    for (const key in formData) {
      if (key === "strategy_id" || key === "bulk_mode" || key === "csrfmiddlewaretoken") continue;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formData[key];
      input.className = "dynamic-input";
      bulkForm.appendChild(input);
    }

    bulkForm.submit();
    return;
  }

  // --- Single strategy download (existing behavior) ---
  let url = new URL(
    `/${formData["strategy_id"]}/download/${type}/`,
    window.location.origin
  );

  if (type === "launcher") {
    url = new URL(
      `/${formData["strategy_id"]}/launch/`,
      window.location.origin
    );
  }

  // Loop for each formData key and append it to searchParams
  for (const key in formData) {
    url.searchParams.append(key, formData[key]);
  }

  window.location.assign(url);
}

window.downloadFile = downloadFile;
